//Activate newTool tooltip and popover from bootstrap
$(function () {
    $('body').tooltip({
        selector: '[title]',
        container: 'body',
        placement: function (tooltip,element){
            var el = $(element);
            var bodyWidth = $(window).width();
            var elLeft = el.offset().left;
            var elWidth = el.outerWidth(true);
            var elTotalWidth = elLeft + elWidth + 100;
            if((elWidth < 200) && (bodyWidth <= elTotalWidth)) {
                return 'right auto';
            } else {
                return 'auto';
            }
        }
    }).on('show.bs.tooltip', function () {
        $('.tooltip').not('.slider .tooltip').remove();
    });
});

// newTool left-nav slideout, see Navbar.jsp and Navbarmobile.jsp
$(function () {

    // Click handler
    jQuery('#mobile-navbar-toggle').on('click', function () {

        // State checker
        if( jQuery('.animated-wrapper').attr('data-state') === 'neutral' ) {
            jQuery('.animated-wrapper').attr('data-state', 'slide-right');
            jQuery('body').css('overflow-x','hidden');
        } else {
            jQuery('.animated-wrapper').attr('data-state', 'neutral');
            jQuery('body').css('overflow-x','');
        }
    });

});

//helpertext input fade out and in on focus and blur
$(function () {
    var $ev = $('.inputs input[type=text], .inputs textarea');
    // fade out on focus
    $ev.bind("focus", function(event) {
            $(this).siblings(".glyphicon").fadeOut();
    });
    //fade in on blur
    $ev.bind("blur", function(event) {
            $(this).siblings(".glyphicon").fadeIn();
    });

});

// activate ellipsis plugin
$(function () {
   //$(".ellipsis").ellipsis();
});